module.exports = __webpack_public_path__ + "img/10.fada5c95.gif";